<template>
  <header
    class="flex items-center h-full mainheader bg-base-0"
    :class="{'searching': searchValue}"
  >
    <span
      v-if="!isDisabled"
      class="px-4 py-4 cursor-pointer lg:hidden"
      @click="showMenuMobile"
    >
      <aha-icon
        name="hamburger-menu"
        class="text-secondary-100"
      />
    </span>

    <!-- Hack: Use div instead of ahref to avoid focus-within state which triggers search UX -->
    <div
      v-if="!isPresenterWhiteLabel"
      class="logo-merge-search-wrapper"
      @click="onClickLogo"
    >
      <img
        v-if="canUseXmasDecoration"
        src="@/assets/images/logos/logo-noel-2023.svg"
        alt=""
        style="max-height: 60px"
      >
      <aha-logo
        v-else
        width="140"
        height="32"
        class="--logo"
      />
    </div>
    <div
      v-if="currentUser.id && !isHideSearchTemplateEu"
      class="merge-template-search-wrapper flex-grow"
      :class="{
        'show': isTemplateSearchVisible,
        'is-zoom-app': isZoomReady,
      }"
    >
      <TemplateSearch></TemplateSearch>
    </div>
    <span class="flex-grow lg:inline-block" :class="{'hidden': !isHideSearchTemplatePage && !isOnboardingV3Showing }" />
    <slot name="language-selection">
      <MultipleLanguage v-if="currentUser.id" class="custom-language" />
    </slot>
    <slot name="notifications">
      <span
        v-if="canShowNotificationsButton"
        class="gradient-gift text-secondary-100 relative noti-icon"
        @click="toggleShowHideNotificationPanel"
      >
        <div class="relative">
          <aha-antd-button
            variant="tertiary"
            icon-name="aha-bell"
            icon-view-box="0 0 16 16"
          >
          </aha-antd-button>
          <span v-if="$store.state.notificationUnread" class="notification-status"></span>
        <!-- Enable khi cần xử dụng lại tính năng push notification -->
        <!-- <PushNotification v-if="currentUser.id && presentations.length" /> -->
        </div>
      </span>
    </slot>
    <a
      v-if="currentUser.referralUserId && !currentUser.referralAwardStatus"
      class="flex mr-4 cursor-pointer gradient-gift text-secondary-100"
      @click="openReferral"
    >
      <img src="@/assets/images/icon/box.svg" class="relative -top-0.5 mr-1">
      <span class="text-gift">{{ $i18nPresenter.t("You’ve got a gift") }}</span>
    </a>
    <span
      class="mr-2 cursor-pointer gradient-gift text-secondary-100 noti-icon"
    >
      <EditorHeaderHelpCenter :is-editor="false" />
    </span>
    <slot name="upgrade-button">
      <span
        v-if="$store.state.plan.group == 'free' && $route.name !== 'Upgrade'"
        v-show="!hasOnboardingV3"
        class="hidden mr-4 lg:inline-block"
        @click="onClickBtnUpgrade(true)"
      >
        <aha-antd-button
          v-aha-emit-action
          name="header-upgrade"
          variant="success"
          class="py-1.5"
        >
          {{ $i18nPresenter.t("Upgrade") }}
        </aha-antd-button>
      </span>

      <span
        v-if="canUseNewBadgeComponent"
        role="button"
        tabindex="0"
        @click="onClickBtnUpgrade"
        @keydown.enter="onClickBtnUpgrade"
        @keydown.space.prevent="onClickBtnUpgrade"
      >
        <aha-antd-plan-badge
          v-if="$store.state.plan.group != 'free'"
          :plan="$store.state.plan.name"
          :isEnterprise="isEnterprise"
          class="hidden mr-4 lg:inline-block cursor-pointer"
        />
      </span>
      <span
        v-else
        @click="onClickBtnUpgrade"
      >
        <aha-plan-badge
          v-if="$store.state.plan.group != 'free'"
          :plan="$store.state.plan.name"
          :isTrial="canShowTrialText"
          class="hidden mr-4 plan-badge lg:inline-block badge-main-header"
        />
      </span>
    </slot>
    <slot name="user-icon-button">
      <aha-dropdown
        v-if="canShowUserIconButton"
        class="hidden lg:inline-block"
      >
        <aha-dropdown-trigger>
          <div
            class="flex items-center cursor-pointer dropdown-wrapper"
            @click="isProfileShowing = true"
          >
            <aha-avatar
              :id="$store.state.currentUser.id"
              :name="`${$store.state.currentUser.firstName} ${$store.state.currentUser.lastName}`"
              :image="$store.state.currentUser.avatar"
              :width="40"
              :height="40"
              class="mr-2 text-lg"
            />
            <aha-icon class="mr-6" name="polygon" />
          </div>
        </aha-dropdown-trigger>
        <transition name="fade" appear>
          <div
            v-if="isProfileShowing"
            v-click-outside="handleClickOutsideProfile"
            class="absolute z-10 p-4 mt-6 rounded-md right-4 bg-base-0 shadow-dialog w-72"
          >
            <div
              class="flex p-2 rounded-md"
              :class="$store.state.plan.color2"
            >
              <aha-avatar
                :id="$store.state.currentUser.id"
                :name="`${$store.state.currentUser.firstName} ${$store.state.currentUser.lastName}`"
                :image="$store.state.currentUser.avatar"
                :width="48"
                :height="48"
                class="text-xl"
              />
              <div class="flex flex-col justify-between py-1 pl-3">
                <p class="font-bold truncate max-w-40">
                  {{ $store.state.currentUser.firstName }} {{ $store.state.currentUser.lastName }}
                </p>
                <p class="text-xs truncate max-w-40">
                  {{ $store.state.currentUser.email }}
                </p>
              </div>
            </div>
            <ul class="aha-menu">
              <li
                v-if="currentUser.identifyProvider != 'skoletube' && !isEnableAddinPowerpoint"
                @click="routeAndClose('/apps/user-profile')"
              >
                <aha-icon name="aha-user-circle2" viewBox="0 0 16 16" />
                <span>{{ $i18nPresenter.t("My Profile") }}</span>
              </li>
              <li
                v-if="currentUser.identifyProvider != 'skoletube' && !hasOnboardingV3 && !isEnableAddinPowerpoint
                  && !isIdealEUplan"
                @click="routeAndClose('/apps/referral')"
              >
                <aha-icon name="dollar-currency-v2" viewBox="0 0 16 16" />
                <span>
                  {{ $i18nPresenter.t("Refer a Friend") }}
                </span>
              </li>
              <li
                v-if="currentUser.identifyProvider != 'skoletube' && !isEnableAddinPowerpoint
                  && (workingMode !== 'team')"
                @click="routeAndClose('/apps/user-plan')"
              >
                <aha-icon name="bill-v2" viewBox="0 0 16 16" />
                <span>{{ $i18nPresenter.t("My Plan") }}</span>
              </li>
              <li
                v-if="currentUser.identifyProvider != 'skoletube' && !isEnableAddinPowerpoint"
                @click="redirectToCustomerPortal"
              >
                <aha-icon name="payment-v2" viewBox="0 0 16 16" />
                <span>{{ $i18nPresenter.t("Billing & Payments") }}</span>
              </li>
              <div class="divider bg-secondary-20 my-2 h-px"></div>
              <li
                v-if="isShowAudienceLoginLink"
                class="audience-login-link"
                @click="loginToAudience"
              >
                <aha-icon name="arrow-square-out-v2" />
                <span>{{ $i18nPresenter.t("sign_in_as_a_participant") }}</span>
              </li>
              <li @click="handleLogoutButtonClick">
                <aha-icon name="log-out-v2" viewBox="0 0 16 16" />
                <span>{{ $i18nPresenter.t("Log out") }}</span>
              </li>
            </ul>
          </div>
        </transition>
      </aha-dropdown>
    </slot>
    <ReferralGift
      v-if="isOpenReferral"
      @hide="closeReferral()"
    />
  </header>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import debounce from 'debounce'
import config from '@/config'
import constants from '@/constant'
import utils from '@/util'
import UserApi from '@/api/user'
import InvitationApi from '@/api/invitation'
import ReferralGift from '@/components-v2/modals/ReferralGift.vue'
import TemplateSearch from '@/components-v2/template/TemplateSearch.vue'
import EditorHeaderHelpCenter from '@/components-v2/presentation-editor/editor-header/EditorHeaderHelpCenter.vue'
import MultipleLanguage from '@/components-v2/multiple-language/MultipleLanguage.vue'
import { ROUTE_NAMES } from '@/constant/routes'

const iconOpenLink = require('@/assets/images/vector.svg')

const { eventCategories } = constants

export default {
  components: {
    ReferralGift,
    TemplateSearch,
    EditorHeaderHelpCenter,
    MultipleLanguage,
  },
  props: {
    isTemplateSearchVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProfileShowing: false,
      searchValue: '',
      tooltipHelp: {
        content: '',
      },
      isOpenReferral: false,
      isLoadingOpenNotification: false,
    }
  },
  computed: {
    ...mapGetters('zoomApp', ['isZoomReady']),
    ...mapGetters('planModule', ['canUseNewBadgeComponent', 'isEnterprise']),
    ...mapGetters('featureToggles', [
      'canUseXmasDecoration',
    ]),
    ...mapState({
      currentUser: (state) => state.currentUser,
      plan: (state) => state.plan,
      isTrialPlan: (state) => state.isTrialPlan,
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3,
      isOnboardingV3Showing: (state) => state.indicators.isOnboardingV3Showing,
      workingMode: (state) => state.workingMode,
      presentations: (state) => state.presentations,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
    redirectRouteName() {
      if (this.isEnableAddinPowerpoint) return ROUTE_NAMES.PRESENTATIONS
      return ROUTE_NAMES.HOME
    },

    isCasualUserNotHaveTeam() {
      return this.currentUser && !this.currentUser.accountId
    },
    isDisabled() {
      return this.$route.name === 'Upgrade'
    },
    isEURegion() {
      return config.region === constants.euRegion
    },
    isIdealEUplan() {
      return this.currentUser.currency === 'eur'
    },
    isHideSearchTemplateEu() {
      if (this.isEURegion && this.$route.name === 'TemplateLibrary') {
        return true
      }

      return false
    },
    isHideSearchTemplatePage() {
      if (this.$route.name === 'TemplateLibrary') {
        return true
      }

      return false
    },
    isShowAudienceLoginLink() {
      return this.currentUser
        && this.currentUser.identifyProvider != 'skoletube'
        && !this.isPresenterWhiteLabel
        && !this.isZoomReady
    },
    canShowTrialText() {
      return this.isTrialPlan && this.currentUser && this.currentUser.personalInformation &&
        this.currentUser.personalInformation.hasSubscribedTrialPlan
    },
    canShowNotificationsButton() {
      return (
        this.currentUser.plan !== 'white-label'
        && !this.isEURegion
        && !this.isZoomReady
      )
    },
    canShowUserIconButton() {
      return this.plan.name
    },
  },
  watch: {
    $route(to) {
      if (to.name === 'Presentations') {
        this.searchValue = this.$route.query.q || ''
      } else if (to.name === 'SharedWithMe') {
        this.searchValue = ''
        InvitationApi.viewInvitation()
      } else {
        this.searchValue = ''
      }
    },
    hasOnboardingV3: {
      handler(value) {
        if (value
          && !this.isOpenReferral
          && this.currentUser
          && this.currentUser.referralUserId
          && !this.currentUser.referralAwardStatus
        ) {
          this.isOpenReferral = true
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.tooltipHelp.content = this.$i18nPresenter.t('ThisLinkOpensInANewTab', { iconOpenLink })
    if (this.$route.query.q) {
      this.searchValue = this.$route.query.q
    }
  },
  methods: {
    ...mapActions(['setIsOnboardingV3ShowingAction', 'createCustomerPortalAction']),
    onClickBtnUpgrade(isUpdate = false) {
      if (this.hasOnboardingV3) return
      if (config.region !== constants.euRegion) {
        let eventLabel = 'Free'
        if (isUpdate) {
          eventLabel = this.$store.state.plan.name
        }
        utils.mixpanelTracking(this.$route.meta.title, 'Presenter App > Header > Upgrade', eventLabel)
        this.$router.push({ name: 'UserPlan' })
      }
    },
    async redirectToCustomerPortal() {
      this.createCustomerPortalAction()
    },
    openReferral() {
      this.isOpenReferral = true
      utils.mixpanelTracking(
        'Presenter Referral Program',
        'Presenter Referral Program > Click open gift ',
        'Click open gift',
      )
    },
    closeReferral() {
      this.isOpenReferral = false
    },

    _hasShowPromotionTeacherPopup(user) {
      return user
        && user.rememberSettings
        && user.rememberSettings.hasShowPromotionTeacherPopup
    },
    handleLogoutButtonClick() {
      utils.logout(this.currentUser)

      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Logout')
    },

    _onSearchInput: debounce(function onSearchInputDebounce() {
      const query = {}
      if (this.searchValue.length !== 1) {
        if (this.searchValue.length > 1) {
          query.q = this.searchValue
        }
        this.$router.push({ name: 'Presentations', query })
      }
    }, 600),

    routeAndClose(path) {
      this.setIsOnboardingV3ShowingAction(false)
      this.$router.push(path)
      this.isProfileShowing = false
      if (window.innerWidth > 1023 && localStorage.getItem(`skipped-welcome-popup-${this.currentUser.id}`) === 'true') {
        this.$emit('showHomeSideBar')
      }
    },

    handleClickOutsideProfile() {
      this.isProfileShowing = false
    },

    showMenuMobile() {
      this.$store.state.indicators.isHomeSideBarShowing = true
    },
    hideMenuMobile() {
      if (window.innerWidth > 1023) return
      this.$store.state.indicators.isHomeSideBarShowing = false
    },
    focusSearch() {
      this.$refs.search.focus()
    },
    onClickLogo() {
      if (this.$route.name === 'Upgrade') {
        // Dont use vue-router on Upgrade page, to clean up state and reload full page.
        this.$func.go(`${config.presenterDomain}/apps/presentations`)
      } else {
        if (this.$store.state.workingMode === 'personal') this.$router.push({ name: this.redirectRouteName })
        else this.$router.push({ name: 'Team' })
        if (this.hasOnboardingV3) {
          this.setIsOnboardingV3ShowingAction(true)
        }
      }
    },
    async toggleShowHideNotificationPanel() {
      this.$store.state.isShowNotificationPanel = !this.$store.state.isShowNotificationPanel
      if (this.$store.state.isShowNotificationPanel) {
        this.$store.state.notificationUnread = 0
        await UserApi.patchUserById(this.currentUser.id, {
          notificationReadTime: new Date(),
        })
      }
      this._trackEvent('Header > Noti > Open', {})
    },
    _trackEvent(action, data, event_label = null) {
      utils.mixpanelTracking(
        this.$route.name,
        action,
        event_label,
        null,
        data,
      )
    },
    loginToAudience() {
      window.open(`${config.audienceDomain}/?tab=account&from=presenter`, '_blank')

      utils.trackGA4AndMixpanel(
        'Sign in as a participant',
        {
          eventAction: 'Sign in as a participant',
          eventCategory: 'Presentation List',
        },
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.search-presentation-wrapper {
  @apply lg:ml-6 flex items-center;
  transition: .15s ease;
}

.search-presentation-wrapper.disabled {
  @apply hidden;
}

.logowrapper {
  @apply opacity-100 flex-grow lg:flex-grow-0 lg:w-auto cursor-pointer;
  transition: .15s ease;
}

.search-presentation-wrapper:hover {
  .search__icon {
    @apply text-primary-90;
  }
}

.mainheader.searching,
.mainheader:focus-within {
  .logowrapper {
    @apply opacity-0 overflow-hidden max-w-0 lg:max-w-full lg:opacity-100 lg:w-auto;
  }
}

.search-presentation-wrapper.has-value,
.search-presentation-wrapper:focus-within {
  @apply w-full max-w-full lg:w-auto;

  .search__icon {
    @apply text-primary-90;
  }

  form {
    @apply w-4/5 lg:w-auto;
  }

  .search__input,
  .search__input:focus {
    @apply opacity-100 mr-4 w-full max-w-full lg:w-56;
  }
}

.search__input {
  @apply outline-none inline-block flex-grow w-0 max-w-56 lg:w-56 mr-2;
  @apply cursor-pointer;
  -webkit-appearance: none;
}

.search__icon {
  @apply text-base-80 lg:text-base-50;
  transition: .15s ease;
}

.aha-menu {
  @apply mt-2;

  li {
    @apply flex items-center;
    @apply leading-10 px-3 hover:bg-base-20 cursor-pointer;
    @apply text-base-90 whitespace-nowrap;
    svg {
      @apply mr-2;
    }
  }
}
.aha-menu-title {
  @apply uppercase tracking-widest text-xs px-3 my-2;
}

.dropdown-wrapper {
  &:hover .dropdown-username {
    @apply text-primary-90;
  }
}
p.dropdown-username {
  @apply capitalize;
  line-height: 1.1rem;
  .credit {
    @apply font-light text-base-80 text-xs;
    margin-top: 2px;
    display: block;

    img {
      position: relative;
      top: -2px;
    }
  }
}

.icon-color {
  opacity: 0.6;
}

.merge-template-search-wrapper {
  @apply hidden;
  &.show {
    @apply block;
  }
}
@media (max-width: 1024px) {
  .text-gift {
    display: none;
  }
  .merge-template-search-wrapper {
    &.is-zoom-app {
      padding-right: 0;
    }
  }
}

.logo-merge-search-wrapper {
  @apply cursor-pointer;

  .--logo {
    @apply block m-auto  lg:ml-3.5;
    margin-top: 2px;
  }

  @media (max-width: 1024px) {
    img {
      max-width: none;
      max-height: 58px !important;
    }
  }

  @media (max-width: 768px) {
    img {
      max-height: 56px !important;
    }
  }
}

.plan-badge{
  &:hover{
    cursor: pointer;
  }
}

.badge-main-header{
  &:hover{
    &.bg-yellow-50{
      box-shadow: 0 1px 10px rgb(255 174 9 / 40%);
    }
    &.bg-green-50{
      box-shadow: 0 1px 10px rgb(40 194 112 / 40%);
    }
    &.bg-purple-50{
      box-shadow: 0 1px 10px rgb(118 105 191 / 40%);
    }
    &.bg-primary-90{
      box-shadow: 0 1px 10px rgb(52 142 246 / 40%);
    }
  }
}

.notification-status {
  width: 6px;
  height: 6px;
  display: block;
  position: absolute;
  top: 8px;
  right: 5px;
  border-radius: 6px;
  background-color: #FF4954;
}

.noti-shadow {
  position: absolute;
  display: block;
  width: 30px;
  height: 36px;
  top: -10px;
  left: -7px;
  background-color: #E0E3ED;
  border-radius: 6px;
  z-index: 5;
  opacity: 0;
  transition: all 0.15s ease-in-out;
}

.noti-icon {
  img {
    position: relative;
  }
  img, .notification-status {
    z-index: 10;
  }
  &:hover {
    .noti-shadow {
      opacity: 1;
    }
  }
}

@media (max-width: 1024px) {
  .noti-icon {
    img {
      width: 18px;
    }
  }

  .noti-shadow {
    top: -9px;
    left: -6px;
  }
}

.logo-mobile {
  display: none;
}

@media (max-width: 767px) {
  .noti-icon {
    position: absolute;
  }
  .gradient-gift {
    display: none;
  }
  .merge-template-search-wrapper {
    padding-right: 0;
  }
}

.custom-language {
  position: unset;

  &::v-deep {
    .aha-dropdown-menu-ai {
      min-width: 120px;
      max-height: 300px;
    }
  }
}

@media (max-width: 560px) {
  .logo-mobile {
    display: inline-block;
  }

  .logo-desktop {
    display: none;
  }
}

</style>
